import { PayoutDestinationModalView, type PayoutState } from './types';

export default (): PayoutState => {
    return {
        hyperwallet: {},
        updateStatus: {
            isUpdating: false,
        },
        modalState: { currentView: PayoutDestinationModalView.SelectOption },
        payoutFrequencyOption: undefined,
        availablePayoutOptions: [],
        displayedPayoutOptions: [],
        requireBankIdVerification: true,
        isFetching: false,
        showSettingsModal: false,
        tink: {
            tinkLinkUrl: '',
            accounts: undefined,
            errorMessage: '',
            isFetching: false,
        },
        bankAccount: { clearingNumber: '', accountNumber: '' },
        paypal: { emailAddress: '' },
        swish: { swishNumber: '', verificationCode: '' },
    };
};
